import { registerPlugin } from '@capacitor/core';

export interface ThemeUtilPlugin {
  setGestureBarColor(options: { color: string }): Promise<void>;
  refreshWindowInsets(): Promise<void>;
}

export const ThemeUtil = registerPlugin<ThemeUtilPlugin>('ThemeUtil');
